export const SCAN = 'scan';
export const UPLOAD = 'upload';
